import {
    initAOS,
} from '@js/common/aos.js';
initAOS();